export const swarmSizes = ["Softball", "Basketball", "Very Large"];
